import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailer_onboarding-alert_banner-view';

/**
 * Tracks view event of alert banner below navigation
 */
export function trackRetailerOnboardingAlertBannerView(
  Alert_Banner_Type_string: string,
  Message_string2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Alert_Banner_Type_string, Message_string2 },
  });
}
